module.exports = __webpack_public_path__ + "static/media/ro.bbddf824.svg";